"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitleText = exports.ErrorText = exports.TitleText = exports.BodyText = exports.TextLink = exports.Text = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = __importDefault(require("../../style/colors"));
var Text_1 = __importStar(require("./Text"));
exports.Text = Text_1.default;
Object.defineProperty(exports, "TextLink", { enumerable: true, get: function () { return Text_1.TextLink; } });
var BodyText = styled_components_1.default(Text_1.default).attrs(function (props) { return (__assign({ size: 16 }, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.BodyText = BodyText;
var ErrorText = styled_components_1.default(Text_1.default).attrs({
    tag: "p",
    size: 12,
    color: colors_1.default.traffic.alertRed
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.ErrorText = ErrorText;
var TitleText = styled_components_1.default(Text_1.default).attrs({
    size: 24,
    bold: true,
    tag: "h1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.TitleText = TitleText;
var PageTitleText = styled_components_1.default(Text_1.default).attrs({
    size: 32,
    bold: true,
    color: colors_1.default.primary.purple
})(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
exports.PageTitleText = PageTitleText;
exports.default = Text_1.default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
